export const OTC_BLOTTER_PREFIX = 'principal/otc-derivatives-1';
